/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { ENTITY_LIMIT_TYPE } from '@jira/polaris__domain-collection/src/entityLimitType.constants.tsx';
import { useNavigationActions } from '@jira/polaris__component-navigation-store/src/useNavigationActions.tsx';
import { JpdNavViews } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/ui/index.tsx';
import type { NavigationCollection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/common/types.tsx';
import { useRoadmapsAnalyticsL2 } from '../../controllers/analytics/use-roadmaps-analytics-l2/index.tsx';
import { useRoadmapsAnalyticsL3 } from '../../controllers/analytics/use-roadmaps-analytics-l3/index.tsx';
import { useRoadmapsAnalyticsL4 } from '../../controllers/analytics/use-roadmaps-analytics-l4/index.tsx';
import { getViewUrl } from '../../utils/router.tsx';
import { useIsReadOnly } from '../../utils/use-is-read-only.tsx';

type RoadmapItemViewsProps = {
	isCollectionSelected?: boolean;
	navigationCollection: NavigationCollection;
};

export const RoadmapItemViews = ({
	navigationCollection,
}: RoadmapItemViewsProps): React.JSX.Element => {
	const { loadViews } = useNavigationActions();

	useEffect(() => {
		loadViews();
	}, [loadViews]);

	return (
		<JpdNavViews<NavigationCollection>
			name="jpd-roadmaps"
			sectionsEnabled
			containerTypePermissions="project"
			container={navigationCollection}
			viewsEntityLimitType={ENTITY_LIMIT_TYPE.VIEWS_PER_COLLECTION}
			viewsetsEntityLimitType={ENTITY_LIMIT_TYPE.VIEWSETS_PER_COLLECTION}
			getViewUrl={getViewUrl}
			dragDropEnabled
			// oxlint-disable-next-line react/react-compiler
			useIsReadOnly={useIsReadOnly}
			// oxlint-disable-next-line react/react-compiler
			useAnalyticsL2={useRoadmapsAnalyticsL2}
			// oxlint-disable-next-line react/react-compiler
			useAnalyticsL3={useRoadmapsAnalyticsL3}
			// oxlint-disable-next-line react/react-compiler
			useAnalyticsL4={useRoadmapsAnalyticsL4}
		/>
	);
};
